<template>
	<Head>
		<Title>{{ pageTitle }} - Timothy Sykes</Title>
		<Link
			rel="canonical"
			:href="`${current_hostname}${$route.name}/`"
		/>
	</Head>
	<Layout>
		<div class="tim-section-default tim-section-light tim-section-top">
			<div class="inner">
				<header
					id="header"
					class="tim-site-header-homework"
					role="banner"
				>
					<ul class="tim-menu-homework">
						<li
							id="menu-item-27802"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27802 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-1/"
								exact-active-class="active"
							>
								Application Received
								<span>Homework 1 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27803"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27803 tim-menu-previous"
						>
							<nuxt-link
								to="/trading-hw-2/"
								exact-active-class="active"
							>
								The Keys To Success
								<span>Homework 2 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27807"
							class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-25434 current_page_item menu-item-27807"
						>
							<nuxt-link
								to="/trading-hw-3/"
								exact-active-class="active"
							>
								Top 10 Effective Trading Tips
								<span>Homework 3 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27805"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27805"
						>
							<nuxt-link
								to="/trading-hw-4/"
								exact-active-class="active"
							>
								My Famous Interviews
								<span>Homework 4 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-35122"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-35122"
						>
							<nuxt-link
								to="/trading-hw-5/"
								exact-active-class="active"
							>
								Fortune Favors The Bold &nbsp;
								<span>Homework 5 of 5</span>
							</nuxt-link>
						</li>
						<li
							id="menu-item-27804"
							class="menu-item menu-item-type-post_type menu-item-object-page menu-item-27804"
						>
							<nuxt-link
								to="/trading-hw-bonus/"
								exact-active-class="active"
							>
								One Last Thought
								<span>Homework Bonus</span>
							</nuxt-link>
						</li>
					</ul>
				</header>
			</div>
		</div>
		<div class="page-content tim-homework-content">
			<div class="video">
				<div class="iframe-wrap">
					<div class="lyte-wrapper">
						<div
							id="WYL_692qgfd_npM"
							class="lyte hidef lP"
						>
							<iframe
								id="iF_692qgfd_npM"
								src="https://www.youtube-nocookie.com/embed/692qgfd_npM?autoplay=1&amp;
                            controls=1&amp;wmode=opaque&amp;
                            rel=0&amp;egm=0&amp;iv_load_policy=3&amp;hd=1&amp;vq=hd720"
								style=""
								allowfullscreen=""
								allow="autoplay"
								width="840"
								height="236"
								frameborder="0"
							/>
						</div>
					</div>
					<div class="lL" />
				</div>
			</div>

			<div
				id="homework"
				class="inner"
			>
				<p>
					<span class="homework">TODAY’S HOMEWORK:</span>
					Check out my top 10 trading rules for 2021. Remember, success is only
					possible with hours of work and study. Big success requires big commitment!
				</p>
				<div
					class="video video-external"
					style="display: none"
				>
					<div class="iframe-wrap">
						<div class="lyte-wrapper">
							<div
								id="WYL_EIbQkDHCc9k"
								class="lyte hidef lP"
							>
								<div
									id="lyte_EIbQkDHCc9k"
									data-src="https://nextsykesdev.wpengine.com/wp-content/
                    plugins/wp-youtube-lyte/
                    lyteCache.php?origThumbUrl=%2F%2Fi.ytimg.com
                    %2Fvi%2FEIbQkDHCc9k%2Fmaxresdefault.jpg"
									class="pL"
								>
									<div class="tC">
										<div class="tT" />
									</div>
									<div class="play" />
									<div class="ctrl">
										<div class="Lctrl" />
										<div class="Rctrl" />
									</div>
								</div>
								<noscript>
									<a
										rel="nofollow"
										href="https://youtu.be/EIbQkDHCc9k"
									>
										<img
											src="https://nextsykesdev.wpengine.com/wp-content/
                      plugins/wp-youtube-lyte/
                      lyteCache.php?origThumbUrl=https%3A%2F%2Fi.ytimg.com
                      %2Fvi%2FEIbQkDHCc9k%2F0.jpg"
											alt=""
											width="420"
											height="216"
										/>
										<br />
										Watch this video on YouTube
									</a>
								</noscript>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="inner">
				<div class="tim-disclaimer">
					<p id="custom-paragraph">
						*Results are not typical and will vary from person to person. Making money
						trading stocks takes time, dedication, and hard work. There are inherent
						risks involved with investing in the stock market, including the loss of
						your investment. Past performance in the market is not indicative of
						future results. Any investment is at your own risk.
						<a
							class="custom-link"
							href="https://www.timothysykes.com/terms-of-service/"
						>
							See Terms of Service here
						</a>
						.
					</p>
				</div>
			</div>
		</div>
	</Layout>
</template>
<script setup>
import Layout from "~/components/layout/Loose.vue";

const { pageTitle, pageContent } = await useLegalPage('trading-hw-3');
</script>
<style scoped>
:deep(.custom-link) {
	background: none;
	padding: 0;
	color: #61a8ef;
	border: none;
	font-size: inherit;
	text-transform: none;
	text-decoration: none;
}

:deep(#homework) {
	text-align: center !important;
}

:deep(#homework p a) {
	color: #1e3a8a;
}

:deep(.lyte-wrapper) {
	width: 420px;
	max-width: 100%;
	/* margin: 5px; */
}

:deep(.lL) {
	max-width: 100%;
	width: 420px;
	/* margin: 5px; */
}

:deep(.video-visible) {
	display: block !important;
}
</style>
